module.exports = __webpack_public_path__ + "static/media/taboola-tutorial.c3671c6f.svg";